import React from 'react';
import {
  TextNoResults,
} from './styles';

const EmptyResultSegment = () => (
  <TextNoResults>Participants in this segment haven’t taken the study yet.</TextNoResults>
);

export default EmptyResultSegment;
